import React, { useState } from "react";
import api from "../../../configs/api";
import FileUploader from "../../ui/FileUploader";
import FileDropzone from "../../ui/FileDropzone";
import { ACCEPT_IMAGES_TYPES_OBJECT, MAX_SIZE_IMAGE } from "../../../utils/constants";
import ShowingFile from "../../ui/ShowingFile";
import Loader from "../../../common/Loader";

export default function AddModal({ handleModal, setIsAdd, isAdd, setStatus }) {
  const [user, setUser] = useState({
    userName: "",
    userComment: "",
    userImage: "https://images.unsplash.com/photo-1719095150877-a1085076c726?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHx0b3BpYy1mZWVkfDExNXx0b3dKWkZza3BHZ3x8ZW58MHx8fHx8",
  });

  const [loading, setLoading] = useState(false);

  const [userImage, setUserImage] = useState([]);

  async function addUser(e) {
    e.preventDefault();
    
    if (!userImage?.[0]?.fileUrl) {
      setStatus({
        show: true,
        icon: "error",
        title: "Main Image is required",
        description: "",
        showConfirmButton: false,
        timer: 5000,
      });
      return;
    }

    try {
      const res = await api.post(`users-comments`, { ...user, userImage: userImage[0].fileUrl });
      setStatus({
        show: true,
        icon: "success",
        title: "User added successfully",
        description: "",
        showConfirmButton: false,
        timer: 5000,
      });
      setIsAdd(false);
    } catch (error) {
      setStatus({
        show: true,
        icon: "error",
        title: "something went wrong, please try again later",
        description: "",
        showConfirmButton: false,
        timer: 5000,
      });
      console.error("Error add user:", error);
    }
  }

  function handleInput(e) {
    setUser({ ...user, [e.target.name]: e.target.value });
  }



  return (
    <>
      {/* Add User Modal */}
      <div
        className={`fixed inset-0 z-50 ${isAdd ? "flex" : "hidden "
          } items-center justify-center p-10 bg-gray-800 bg-opacity-50 overflow-x-hidden overflow-y-auto`}
      >
        <div className='relative w-full h-[80%] max-w-2xl px-4 overflow-y-auto '>
          {/* Modal content */}
          <div className='relative bg-white rounded-lg shadow dark:bg-gray-800'>
            {/* Modal header */}
            <div className='flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700'>
              <h3 className='text-xl font-semibold dark:text-white'>
                Add new Parent comment
              </h3>
              <button
                onClick={() => handleModal(setIsAdd, false)}
                type='button'
                className='text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white'
                data-modal-toggle='add-user-modal'
              >
                <svg
                  className='w-5 h-5'
                  fill='currentColor'
                  viewBox='0 0 20 20'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    fillRule='evenodd'
                    d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                    clipRule='evenodd'
                  />
                </svg>
              </button>
            </div>
            {/* Modal body */}
            <div className='p-6 space-y-6'>
              <form onSubmit={(e) => addUser(e)}>
                <div className='flex flex-col gap-4'>
                  <div className='w-full'>
                    <label
                      htmlFor='userName'
                      className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
                    >
                      Parent Name
                    </label>
                    <input
                      onChange={(e) => handleInput(e)}
                      type='text'
                      name='userName'
                      id='userName'
                      className='shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                      placeholder='Parent Name'
                      required
                      defaultValue={user?.userName}
                    />
                  </div>
                  <div className='w-full'>
                    <label
                      htmlFor='userComment'
                      className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
                    >
                      Parent Comment
                    </label>
                    <input
                      onChange={(e) => handleInput(e)}
                      type='text'
                      name='userComment'
                      id='userComment'
                      className='shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                      placeholder='Child Condition'
                      required
                      defaultValue={user?.userComment}
                    />
                  </div>
                </div>
                <br />

                {userImage?.length === 0 ?
                  <FileDropzone
                    setState={setUserImage}
                    value={userImage}
                    filesAccept={ACCEPT_IMAGES_TYPES_OBJECT}
                    name="specialistImage"
                    maxSize={MAX_SIZE_IMAGE}
                    setLoading={setLoading}
                  />
                  :
                  <ShowingFile values={userImage} setValues={setUserImage} />
                }

                <div className='flex items-center pt-5 mt-5 justify-center border-t border-gray-200 rounded-b dark:border-gray-700 '>
                {loading ?
                    <Loader isFullScreen={false} />
                    :
                  <button
                    className='text-white bg-primary hover:bg-buttonFocus focus:ring-4 focus:ring-buttonFocus font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-buttonHover dark:hover:bg-primary dark:focus:ring-buttonFocus'
                    type='submit'
                  >
                    Add Parent Comment
                  </button>
}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
